import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "name", "disabled", "title", "checked", "data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    id: _ctx.id,
    name: _ctx.id,
    type: "checkbox",
    disabled: _ctx.disabled,
    title: _ctx.disabled ? _ctx.disabledReason : '',
    checked: _ctx.checked,
    "data-testid": _ctx.id,
    class: _normalizeClass({
      'tw-h-4 tw-w-4 tw-rounded tw-border tw-border-solid tw-border-slate-300': true,
      'tw-cursor-pointer tw-text-deep-orange-500 focus:tw-ring-deep-orange-500': !_ctx.disabled,
      'tw-cursor-not-allowed tw-text-slate-300': _ctx.disabled
    })
  }, null, 10, _hoisted_1))
}